import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Departamento, Empregador } from '../../api.service';
import { RodapeCrudComponent } from '../../shared/rodape-crud.component';
import { ServicoMensagemAplicacao } from '../../shared/servico-mensagem-aplicacao';
import { ServicoDepartamentoAdministrativo } from './servico-departamento-administrativo';

@Component({
  selector: 'app-tela-departamentos',
  standalone: true,
  imports: [CommonModule, FormsModule, RodapeCrudComponent],
  templateUrl: './tela-departamentos.component.html'
})
export class TelaDepartamentosComponent implements OnChanges {
  @Input() empregadores: Empregador[] = [];
  @Input() empregadorSelecionado = '';

  @Output() empregadorSelecionadoChange = new EventEmitter<string>();
  @Output() carregarDepartamentos = new EventEmitter<void>();
  @Output() mensagem = new EventEmitter<string>();

  departamentosCadastro: Departamento[] = [];
  departamentoSelecionado = '';
  departamento: Departamento = this.servicoDepartamento.novoDepartamento();

  constructor(
    private readonly servicoDepartamento: ServicoDepartamentoAdministrativo,
    private readonly servicoMensagemAplicacao: ServicoMensagemAplicacao
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['empregadorSelecionado']) {
      this.limparDepartamento();
      this.recarregarCadastro();
    }
  }

  selecionarEmpregador(empregadorId: string) {
    this.empregadorSelecionado = empregadorId;
    this.empregadorSelecionadoChange.emit(empregadorId);
    this.limparDepartamento();
    this.recarregarCadastro();
    this.carregarDepartamentos.emit();
  }

  selecionarDepartamento(departamentoId: string) {
    this.departamentoSelecionado = departamentoId;
    const selecionado = this.departamentosCadastro.find(item => item.id === departamentoId);
    this.departamento = this.servicoDepartamento.prepararEdicao(selecionado, this.empregadorSelecionado);
  }

  rotuloDepartamento(departamento: Departamento): string {
    return this.servicoDepartamento.rotuloDepartamento(departamento);
  }

  recarregarCadastro() {
    this.servicoDepartamento.listarPorEmpregadorSelecionado(this.empregadorSelecionado, true).subscribe({
      next: departamentos => this.departamentosCadastro = departamentos,
      error: erro => this.mensagem.emit(this.servicoMensagemAplicacao.erroApi(erro, 'Erro ao carregar departamentos.'))
    });
  }

  atualizarLista() {
    this.recarregarCadastro();
    this.carregarDepartamentos.emit();
  }

  limparDepartamento() {
    this.departamentoSelecionado = '';
    this.departamento = this.servicoDepartamento.novoDepartamento(this.empregadorSelecionado);
  }

  salvarDepartamento() {
    if (!this.empregadorSelecionado) {
      this.mensagem.emit('Selecione um empregador.');
      return;
    }
    const editando = !!this.departamento.id;
    this.servicoDepartamento.salvar({ ...this.departamento, empregadorId: this.empregadorSelecionado }).subscribe({
      next: salvo => {
        this.departamento = this.servicoDepartamento.prepararEdicao(salvo, this.empregadorSelecionado);
        this.departamentoSelecionado = salvo.id || '';
        this.mensagem.emit(this.servicoMensagemAplicacao.registroSalvo(editando));
        this.recarregarCadastro();
        this.carregarDepartamentos.emit();
      },
      error: erro => this.mensagem.emit(this.servicoMensagemAplicacao.erroApi(erro, 'Erro ao salvar departamento.'))
    });
  }

  excluirDepartamento() {
    if (!this.departamento.id || !window.confirm('Confirma excluir este departamento?')) {
      return;
    }
    this.servicoDepartamento.excluir(this.departamento.id).subscribe({
      next: () => {
        this.mensagem.emit(this.servicoMensagemAplicacao.registroExcluido());
        this.limparDepartamento();
        this.recarregarCadastro();
        this.carregarDepartamentos.emit();
      },
      error: erro => this.mensagem.emit(this.servicoMensagemAplicacao.erroApi(erro, 'Erro ao excluir departamento.'))
    });
  }
}
